import type { PropertyName } from "@frui.ts/helpers/dist";
import type { IHasAutomaticValidation } from "@frui.ts/validation";

export default function hasRequiredProperty<TTarget>(entity: IHasAutomaticValidation<TTarget>, property: PropertyName<TTarget>) {
  if (entity.__validation.sourceValidationRules[property]?.requiredIf) {
    return entity.__validation.sourceValidationRules[property]?.requiredIf.condition(entity);
  }

  return !!entity.__validation.sourceValidationRules[property]?.required;
}
